var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page gc" }, [
    _c("div", { staticClass: "page-menu g3" }),
    _vm._v(" "),
    _c("div", { staticClass: "page-content g9" }, [
      _c("h2", [_vm._v("Settings")]),
      _vm._v(" "),
      _c("div", { staticClass: "accord", class: { closed: _vm.isClosed } }, [
        _c("header", { on: { click: _vm.onToggle } }, [
          _vm._v("Settings"),
          _c("span", { attrs: { title: "open / close" } }),
        ]),
        _vm._v(" "),
        !_vm.isClosed
          ? _c(
              "article",
              [
                _vm._t("default", function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "grid-100w" },
                      _vm._l(_vm.settings, function (setting) {
                        return _c(
                          "div",
                          { key: setting.settingId, staticClass: "input" },
                          [
                            _c("label", [
                              _c("span", [
                                _vm._v(" " + _vm._s(setting.settingKey)),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: setting.settingValue,
                                    expression: "setting.settingValue",
                                  },
                                ],
                                attrs: { type: "text" },
                                domProps: { value: setting.settingValue },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      setting,
                                      "settingValue",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "left",
                        class: { loading: _vm.isSaving },
                        attrs: { type: "button" },
                        on: { click: _vm.saveAllSettings },
                      },
                      [_vm._v("\n            Save\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "right",
                        class: { loading: _vm.isStopping },
                        attrs: { type: "button" },
                        on: { click: _vm.stopWebsite },
                      },
                      [_vm._v("\n            Restart website\n          ")]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.hasBeenStoppedMessage) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "accord", class: { closed: _vm.createNewIsClosed } },
        [
          _c("header", { on: { click: _vm.onToggleNewSetting } }, [
            _vm._v("New setting"),
            _c("span", { attrs: { title: "open / close" } }),
          ]),
          _vm._v(" "),
          !_vm.createNewIsClosed
            ? _c(
                "article",
                [
                  _vm._t("default", function () {
                    return [
                      _c("div", { staticClass: "grid-100w" }, [
                        _c("h4", [
                          _vm._v(
                            "\n            Create a new setting here.\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Please note this is stricly for admin/dev. Field can be boolean (1 or 0) or any other type fo setting. Settings cannot delete a setting."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input" }, [
                          _c("label", [
                            _c("span", [_vm._v(" Setting value")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newSetting.settingValue,
                                  expression: "newSetting.settingValue",
                                },
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.newSetting.settingValue },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newSetting,
                                    "settingValue",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input" }, [
                          _c("label", [
                            _c("span", [_vm._v(" Setting key")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newSetting.settingKey,
                                  expression: "newSetting.settingKey",
                                },
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.newSetting.settingKey },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newSetting,
                                    "settingKey",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "left",
                          class: { loading: _vm.isSaving },
                          attrs: { type: "button" },
                          on: { click: _vm.createNewSetting },
                        },
                        [_vm._v("\n            Save\n          ")]
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticStyle: {
            width: "250px",
            float: "right",
            "text-align": "right",
            "margin-top": "10px",
          },
        },
        [
          _c("p", [
            _vm._v(
              "Restarting website is\n              necessary for some settings to take effect. Please note you must reload you browser and may need to\n              login again."
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }